import { render, staticRenderFns } from "./DynamicDeepLink.vue?vue&type=template&id=3ff282fb"
import script from "./DynamicDeepLink.vue?vue&type=script&lang=ts"
export * from "./DynamicDeepLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports